<template>
	<div class="keyword-operation-log-main-div" v-loading="loading">
		<div class="search-head">
			<el-row :gutter="20">
				<el-form label-width="50px" :model="search" :rules="formRules" ref="ruleForm">
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="7">
						<el-form-item label="时间">
							<el-date-picker v-model="expenditureDate" type="daterange" range-separator="至"
								style="width: 100%"
								start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="7">
						<el-form-item label="功能">
							<el-select v-model="search.module" placeholder="请选择" style="width: 100%">
								<el-option :value="null">全部</el-option>
								<el-option v-for="item in operationModuleList" :key="item.type" :label="item.cn" :value="item.type"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
<!--					<el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="7">-->
<!--						<el-form-item label="IP" prop="ip">-->
<!--							<el-input v-model="search.ip"></el-input>-->
<!--						</el-form-item>-->
<!--					</el-col>-->
					<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="10">
						<div style="float: right;margin-bottom: 22px">
							<el-button @click="submitLoadForm('ruleForm')" type="primary" icon="fa fa-search"></el-button>
						</div>
					</el-col>
				</el-form>
			</el-row>
		</div>
		<el-table :data="searchData.list" style="width: 100%">
			<el-table-column prop="createTime" label="时间" width="180" align="center">
				<template slot-scope="scope">
					{{ $fomatTime(scope.row.createTime, 'yyyy-MM-DD HH:mm:ss') }}
				</template>
			</el-table-column>
			<el-table-column label="功能" align="center" width="200">
				<template slot-scope="scope">
					{{ getOperationModuleCnByType(scope.row.module) }}
				</template>
			</el-table-column>
			<el-table-column prop="logType" label="描述">
				<template slot-scope="scope">
					{{ getOperationTypeCnByType(scope.row.logType) }}
				</template>
			</el-table-column>

<!--			<el-table-column prop="requestIp" label="UA" align="left" show-overflow-tooltip>-->
<!--				<template slot-scope="scope">-->
<!--					{{ scope.row.userAgent }}-->
<!--				</template>-->
<!--			</el-table-column>-->

<!--			<el-table-column prop="requestIp" label="IP地址" align="left" width="150">-->
<!--				<template slot-scope="scope">-->
<!--					{{  scope.row.requestIp  }}-->
<!--				</template>-->
<!--			</el-table-column>-->
<!--			<el-table-column prop="requestIp" label="IP归属地" width="170" show-overflow-tooltip>-->
<!--				<template slot-scope="scope">-->
<!--					{{  scope.row.address  }}-->
<!--				</template>-->
<!--			</el-table-column>-->
			<el-table-column prop="logType" label="备注" width="90" align="center" fixed="right">
				<template slot-scope="scope">
					操作{{ scope.row.failed ? '失败' : '成功' }}
				</template>
			</el-table-column>
		</el-table>

		<div class="page-div">
			<el-pagination background
				layout="prev, pager, next"
				:current-page="search.page"
				:page-size="search.pageSize"
				@current-change="currentChange"
				:total="searchData.total" hide-on-single-page>

			</el-pagination>
		</div>
	</div>
</template>

<script>
import { api_keywordsLogList_operationLog } from "@/components/api/operationLog";
import { getOperationTypeCnByType } from "@/components/config/operationTypeLog";
import { getOperationModuleCnByType, OPERATION_MODULE_MAP } from "@/components/config/operationLogModuleEnum";
import { dateAdd } from "@/components/common/utils/time";

export default {
	name: "OperationLog",
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg'],
	data() {
		let validateIP = function(rule, value, callback) {
			if (value === '' || typeof value === 'undefined' || value == null) {
				callback()
			} else {
				const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
				if ((!reg.test(value)) && value !== '') {
					callback(new Error('请输入正确的IP地址'))
				} else {
					callback()
				}
			}
		}
		return {
			operationModuleList: OPERATION_MODULE_MAP,
			loading: false,
			search: {
				page: 1,
				pageSize: 15,
				module: null,
				ip : null
			},
			formRules: {
				ip: [
					{ required: false, message: '请输入正确的IP地址', validator: validateIP, trigger: 'blur' }
				]
			},
			searchData: {},
			expenditureDate: [new Date(new Date().getTime() - 1000 * 3600 * 24 * 7), new Date()],
		}
	},
	props: {},
	created() {
		this.$options.methods.loadData(this)
	},
	methods: {
		currentChange: function(page) {
			this.$data.search.page = page
			this.$options.methods.loadData(this)
		},
		submitLoadForm : function(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$options.methods.loadData(this)
				}
			});
		},
		loadData: function(this_) {
			this_ = this_ || this
			let obj = JSON.parse(JSON.stringify(this_.$data.search))
			if (this_.$data.expenditureDate){
				obj.startTime = this_.$data.expenditureDate[0]
				obj.endTime = dateAdd(new Date(this_.$data.expenditureDate[1]),'d',1)
			}
			// 开启遮罩
			this_.$data.loading = true
			api_keywordsLogList_operationLog(obj).then(res => {
				this_.$data.searchData = res.data
				this_.$data.loading = false
			}).catch(err => {
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '日志加载错误'), 4)
			})
		},
		getOperationTypeCnByType: function(v) {
			return getOperationTypeCnByType(v)
		},
		getOperationModuleCnByType: function(v) {
			return getOperationModuleCnByType(v)
		}
	}
}
</script>

<style scoped>
.keyword-operation-log-main-div {
	width: 100%;
}

.search-head {
	padding: 20px 10px;
}

.page-div {
	padding: 20px 0px;
	text-align: center;
}
</style>